/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Page_TitleInputs */

const de_orders_page_title = /** @type {(inputs: Orders_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestellungen`)
};

/** @type {(inputs: Orders_Page_TitleInputs) => LocalizedString} */
const en_orders_page_title = de_orders_page_title;

/**

* @param {Orders_Page_TitleInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const orders_page_title = /** @type {((inputs?: Orders_Page_TitleInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Page_TitleInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_orders_page_title(inputs)
	return en_orders_page_title(inputs)
});